<template>
  <app-view>
    <div class="content">
      <a
        href="javascript:;"
        class="item"
        v-for="(item,i) in notes"
        :key="i"
        @click="onEdit(i)"
        @touchstart.passive="onTouchStart(i)"
        @touchmove.passive="onTouchEnd"
        @touchend.passive="onTouchEnd"
      >
        <div>
          <span>{{item.subtitle}}</span>
          <span></span>
        </div>
        <div>
          <span>{{item.title}}</span>
          <span>{{item.addtime | datetime}}</span>
        </div>
      </a>
    </div>
    <div class="none" v-if="none">暂时没有笔记</div>
    <div class="tip">提示：长按可进行删除操作</div>
    <app-confirm ref="confirm"></app-confirm>
  </app-view>
</template>
<script>
import AppConfirm from '../components/AppConfirm.vue'

export default {
  components: { AppConfirm },
  data() {
    return {
      notes: {},
      tap: 0
    }
  },
  computed: {
    none() {
      return Object.keys(this.notes).length === 0
    }
  },
  async mounted() {
    let { data } = await this.$service.user.getNotes()
    this.notes = data
  },
  methods: {
    onTouchStart(i) {
      this.tap = setTimeout(() => {
        this.onDelete(i)
      }, 1000)
    },
    onTouchEnd() {
      clearTimeout(this.tap)
    },
    async onDelete(i) {
      if (await this.$refs.confirm.show('您确定要删除该笔记吗?')) {
        let item = this.notes[i]
        await this.$service.user.removeNote(item.id)
        this.notes.splice(i, 1)
      }
    },
    onEdit(i) {
      let item = this.notes[i]
      this.$router.push({
        name: 'note-editor',
        params: {
          movid: item.tid,
          urlid: item.urlid
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.view {
  padding-bottom: 50px;
  .none {
    padding-top: 100px;
    text-align: center;
    color: $secondly-text-color;
  }
  .tip {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    font-size: 12px;
    padding: 2px 0;
    background-color: $color-white;
    text-align: center;
    color: $secondly-text-color;
  }
  .item {
    display: block;
    background-color: $color-white;
    border-bottom: $style-border;
    padding: $app-padding;
    &:active {
      background-color: rgba(0, 0, 0, 0.1);
    }
    > div {
      display: flex;
      > span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:first-child {
          flex: 1;
        }
        &:last-child {
          font-size: 12px;
          text-align: right;
          color: $secondly-text-color;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?30797b37